var exports = {
  "success": "PurchaseHistoryStatus.module__success___c1lwMG",
  "pending": "PurchaseHistoryStatus.module__pending___c1lwMG",
  "muted": "PurchaseHistoryStatus.module__muted___c1lwMG",
  "neutral": "PurchaseHistoryStatus.module__neutral___c1lwMG",
  "danger": "PurchaseHistoryStatus.module__danger___c1lwMG",
};

__webpack_require__.r(module.exports = exports);
